module.exports = __webpack_public_path__ + "img/sf.9b8d8ed8.jpg";